import './component.scss';

export class Room
{

	constructor(id)
	{
		if (!!id) {
			this.id = id
			this.open = true
			this.finish = false
			this.$room = $(`#${this.id}`)
			this.authorized = (this.$room.data('authorized') == 'Y' ? true : false)
			this.$timer = this.$room.find('.js-timer')
			this.$chosed = this.$room.find('.js-chosed-places')
			this.$places = this.$room.find('.js-room-places')

			this.$cardUse = this.$room.find('input[name="usePoints"]')
			this.$cardBodyCanPay = this.$room.find('.js-hall-card-body-can-pay')
			this.$cardBodyCantPay = this.$room.find('.js-hall-card-body-cannt-pay')
			this.$pointsUse = this.$room.find('.js-hall-card-points-use')

			this.chosedPlaces = [];
			this.fullPrice = 0;
			this.reservationId = 0;
			this.settings = {
				maxBookingPlaces: 6,
				maxReservationTime: 15 // minutes
			}

			this.primaryColor = '#ED7D00'
			this.secondaryColor = '#DCDFE0'

			this.init()
		} else {
			console.error('No id in construktor')
			return null
		}
	}

	init()
	{
		this.initHandlers()
		this.initScroll()
		this.initPopover()

		this.update()
	}

	initHandlers()
	{
		var _this = this

		$('.js-toggle-close-dialog').on('click', function(e) {
			e.preventDefault()
			$(this).parents('.panel').find('.js-auth__modal-close').toggleClass('is-show')
		})

		$('.js-toggle-close-auth').on('click', function(e) {
			e.preventDefault()
			$(this).parents('.panel').find('.js-auth__modal-auth').toggleClass('is-show')
		})

		$('.js-toggle-adult-dialog').on('click', function(e) {
			e.preventDefault()
			$(this).parents('.panel').find('.js-auth__modal-adult').toggleClass('is-show')
		})

		$('.js-close-order').on('click', function(e) {
			e.preventDefault()
			_this.closeWithCancel()
			$(this).parents('.panel').find('.js-auth__modal-close').removeClass('is-show')
		})

		$('.js-seat-click').on('click', function(e) {
			e.preventDefault()
			_this.seatClick($(this))

			let reservationGid = $(this).data('reservation-gid')
			if (reservationGid != '') {
				$(this).data('reservation-gid', '')
				_this.cancelPlaceReservation(reservationGid)
			}
		})

		this.$chosed.on('click', '.js-chosed-place-remove', function(e) {
			e.preventDefault()

			let $chosedPlace = $(this).closest('.js-chosed-place'),
				mixid = $chosedPlace.data('mixid'),
				reservationGid = $chosedPlace.data('reservation-gid')

			_this.removeByMixid(mixid)

			if (reservationGid != '') {
				$chosedPlace.data('reservation-gid', '')
				_this.cancelPlaceReservation(reservationGid)
			}
		})

		$('.js-go-email-popup').on('click', function(e) {
			e.preventDefault()
			if (!$(this).hasClass('btn-disabled')) {
				_this.$chosed.addClass('pointer-events-none')
				_this.goReservationStep()
			}
		})

		$('.js-go-pay').on('click', function(e) {
			e.preventDefault()
			if (!$(this).hasClass('btn-disabled')) {
				_this.goPayStep()
			}
		})

        $('.js-go-pay-ball').on('click', function(e) {
            e.preventDefault()
            if (!$(this).hasClass('btn-disabled')) {
                _this.goPayStep('pushkinskaya')
            }
        })

		$('.js-go-auth').on('click', function(e) {
			e.preventDefault()
			_this.closeWithoutCancel()

			setTimeout(function(){
				$('.js-fancybox-auth').trigger('click')
			}, 250)
		})

		$(window).on('beforeunload', function() {
			if (!this.finish && _this.open) {
				return 'Покупка билетов еще не закончена. Вы уверены что хотите уйти?';
			}
		})
		
		$(window).on('unload', function() {
			if (!this.finish && _this.open) {
				_this.cancelAllReservation()
			}
		})

        this.$room.find('[data-required]').on('keyup', function(e) {
            let $input = $(this),
				count = $input.data('required'),
				validation = true
			
			if ($input.attr('type') == 'email') {
				validation = $().vlkinoEmailValidation($input.val())
			}

            if ((count > 0 && $input.val().length < count) || validation === false) {
                _this.$room.find('.js-submit').addClass('btn-disabled')
            } else {
                _this.$room.find('.js-submit').removeClass('btn-disabled')
            }
		})
        
        

		this.$cardUse.on('change', function(){
			if (_this.fullPrice*0.3 > $(this).val()) {
                _this.$cardBodyCanPay.slideUp()
				return
			}

            _this.$cardBodyCanPay.slideDown()
		})


	}

	initScroll()
	{
		$('.js-custom-scroll-x').mCustomScrollbar({
			axis: 'x',
			theme: 'light',
			advanced: { autoExpandHorizontalScroll: true }
		})
	}

	initPopover()
	{
		if ($(window).width() < 992) {
			return;
		}

		$('.js-seat-popover').each(function(i,el) {
			let wrap = $(el).parents('.panel')
	
			$(el).popover({
				placement: 'top',
				html: true,
				trigger: 'hover',
				container: wrap
			})
		})
	}

	seatClick($place)
	{
		let chosed = `<span class="seat__chosed seat--l${$place.data('zone-gid')}` + ($place.hasClass('seat--lg') ? ' seat--lg' : '') + `"></span>`

		if (!$place.hasClass('is-reserve') && this.chosedPlaces.length < this.settings.maxBookingPlaces) {
			$place.addClass('is-reserve').html(chosed)
		} else if ($place.hasClass('is-reserve')) {
			$place.removeClass('is-reserve').html('')
		} else {
			alert(`За раз можно купить не более ${this.settings.maxBookingPlaces} мест.`)
		}

		this.update()
	}

	update()
	{
		this.updateChosedPlaces()
		this.updateFullPrice()
	}

	updateChosedPlaces()
	{
		this.fillChosedPlaces()
		this.paintChosedPlaces()
		this.updateScroll()
	}

	fillChosedPlaces()
	{
		let _this = this,
			$roomPlaces = this.$room.find('.js-room-places')

		this.chosedPlaces = []

		$roomPlaces.find('.is-reserve').each(function() {
			_this.chosedPlaces.push($(this))
		})
	}

	clearChosedPlaces()
	{
		this.$chosed.html('')
	}

	paintChosedPlaces()
	{
		this.clearChosedPlaces()

		this.chosedPlaces.forEach((item) => {
			this.addChosedPlace(item)
		})
	}

	addChosedPlace($place)
	{
		let reservationGid = ($place.data('reservation-gid') ? $place.data('reservation-gid') : 0)

		this.$chosed.append(`<div` +
			` class="btn btn-light place js-chosed-place js-chosed-place--${$place.data('mixid')}"` +
			` data-mixid="${$place.data('mixid')}"` +
			` data-row="${$place.data('row')}"` +
			` data-place="${$place.data('place')}"` +
			` data-price="${$place.data('price')}"` +
			` data-reservation-gid="${reservationGid}"` +
		`>` +
			`<div class="place__row">Ряд: ${$place.data('row')}</div>` +
			`<div class="place__place">Место: ${$place.data('place')}</div>` +
		`</div>`)
	}

	getChosedPlaceMixids()
	{
		var mixids = [];

		this.chosedPlaces.forEach((item) => {
			mixids.push(item.data('mixid'))
		})

		return mixids
	}

	removeByMixid(mixid)
	{
		this.$places.find('.js-seat-click--' + mixid)
			.data('reservation-gid', '')
			.removeClass('is-reserve')

		this.$chosed.find('.js-chosed-place--' + mixid).remove()

		this.update()
	}

	updateScroll()
	{
		$('.mCSB_container').width('auto').height('auto')
		$('.mCustomScrollbar').mCustomScrollbar("update")
	}

	updateFullPrice()
	{
		this.calculateFullPrice()
		this.paintFullPrice()
	}

	calculateFullPrice()
	{
		this.fullPrice = 0;
		this.chosedPlaces.forEach((item) => {
			this.fullPrice += item.data('price')
		})
	}

	paintFullPrice()
	{
		var pricePrint = this.fullPrice + ' р',
			$btn = this.$room.find('.js-places-chosed-full-price-print')

		$btn.html(pricePrint)

		if (this.fullPrice > 0) {
			$btn.removeClass('btn-disabled')
		} else {
			$btn.addClass('btn-disabled')
		}
	}

	goReservationStep()
	{
		this.reservation()
		this.showEmailStep()
		this.initTimer()
		this.loyaltyInit()
	}

	loyaltyInit()
	{
		if (this.$cardUse == false) {
			return
		}

		if (this.fullPrice*0.3 > this.$cardUse.val()) {
		    $('#usePoints').parent().addClass('d-none');
            $('.js-hall-card-use').parent().addClass('d-none');
        }
	}

	showEmailStep()
	{
		$('#step-1, #step-1-1').hide()

		if (this.authorized === false) {
			this.$room.find('.js-auth__modal-auth').addClass('is-show')
		}

		$('#step-2').show()
	}

	initTimer()
	{
		this.$timer.show()

		let secondInMinute = 60,
			timeoutMinutes = this.settings.maxReservationTime,
			timeoutSeconds = secondInMinute * timeoutMinutes,
			min = Math.floor(timeoutSeconds / secondInMinute),
			sec = (timeoutSeconds % secondInMinute),
			$timerHtml = this.$timer.find('.js-timer__time')
		
		$timerHtml.html((min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec)

		let timerId = setInterval(() => {
			if (timeoutSeconds > 0) {
				--timeoutSeconds
				min = Math.floor(timeoutSeconds / secondInMinute)
				sec = (timeoutSeconds % secondInMinute)
				this.$timer.data('timeoutSeconds', timeoutSeconds)
				$timerHtml.html((min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec)
			} else {
				this.closeWithMessage()
				clearInterval(this.$timer.data('timerId'))
			}
		}, 1000)

		this.$timer.data('timerId', timerId)
	}

	reservation()
	{
		let objData = {
				scheduleGid: this.$room.data('schedule-gid'),
				chosedPlaceMixids: this.getChosedPlaceMixids()
			}

		this.lockPopup()

		$.ajax({
			method: 'POST',
			url: '/local/ajax/api/v1/reservation/',
			data: objData,
			dataType: 'json'
		})
		.done((response) => {
			if (response.success == true) {
				console.log('success reservation')
			} else {
            	$('.js-go-pay').text('Ошибка брони').attr('disabled', 'disabled');
            }
		})
		.fail((jqXHR, textStatus) => {
			console.log(textStatus)
		})
		.always(() => {
			this.lockPopup()
		})
	}

	cancelReservation(reservationGids = [])
	{
		if (reservationGids.length < 1) {
			return
		}

		let objData = {
				scheduleGid: this.$room.data('schedule-gid'),
				reservationGids: reservationGids
			}

		this.lockPopup()

		$.ajax({
			method: 'POST',
			url: '/local/ajax/api/v1/cancelReservation/',
			data: objData,
			dataType: 'json'
		})
		.done((response) => {
			if (response.success == true) {
				console.log('success reservation cancel')
			}
		})
		.fail((jqXHR, textStatus) => {
			console.log(textStatus)
		})
		.always(() => {
			this.lockPopup()
		})
	}

	cancelAllReservation()
	{
		// TODO: implement this method
		this.cancelReservation([])
	}

	cancelPlaceReservation(reservationGid)
	{
		let reservationGids = [reservationGid]
		this.cancelReservation(reservationGids)
	}

	goPayStep(add = '')
	{
		let bUsePoints = this.$cardUse.is(':checked'),
			usePoints = $('input[name="usePoints"]:checked').val(),
			objData = {
				email: $('.js-auth__email').val(),
				bUsePoints: bUsePoints ? 'Y' : 'N',
				usePoints: usePoints
			}
		
		this.lockPopup()
        
        if (add !== '') {
            objData.card = add;
        }

		$.ajax({
			method: 'POST',
			url: '/local/ajax/api/v1/pay/',
			data: objData,
			dataType: 'json'
		})
		.done((response) => {
			if (response.success == true && !!response.redirect) {
				this.redirectToPay(response.redirect)
			} else {
				this.lockPopup()
			}
		})
		.fail((jqXHR, textStatus) => {
			console.log(textStatus);
			this.lockPopup()
		})
	}

	redirectToPay(redirect)
	{
		this.finish = true
		this.open = false

		setTimeout(function(){
			window.location = redirect
		}, 150)
	}

	closeWithoutCancel()
	{
		this.open = false
		this.removeHandlers()
		clearInterval(this.$timer.data('timerId'))
		$.fancybox.close(true)
		$('.panel__close-box').removeClass('is-show')
	};

	closeWithCancel()
	{
		this.open = false
		this.cancelAllReservation()
		this.removeHandlers()
		clearInterval(this.$timer.data('timerId'))
		$.fancybox.close(true)
		$('.panel__close-box').removeClass('is-show')
	}

	closeWithMessage(message = 'Время на резервирование и покупку мест закончилось. Вам нужно пройти резервированиие заново.')
	{
		// this.$room.find('.js-auth__modal-close-message-text').html(message)
		this.$room.find('.js-auth__modal-close-message').addClass('is-show')
	}

	removeHandlers()
	{
		$('.js-toggle-close-dialog').unbind('click')
		$('.js-toggle-close-auth').unbind('click')
		$('.js-close-order').unbind('click')
		$('.js-seat-click').unbind('click')
		this.$chosed.unbind('click')
		$('.js-go-email-popup').unbind('click')
		$('.js-go-pay').unbind('click')
		$('.js-go-auth').unbind('click')
		$(window).unbind('beforeunload')
		$(window).unbind('unload')
		this.$room.find('[data-required]').unbind('keyup')
	}

	lockPopup()
	{
		this.$room.find('.panel__loader').vlkinoLock()
	}

}
